module.exports = __webpack_public_path__ + "img/B8.c43e761a.png";